<template>
  <div>
	  <Top username="" signout="/master/login"/>
	   <div class="content-wrapper back">
      <div class="containers">
        <section class="content-header">
          <div class="row">
            <img
              src="assets/images/ug1.jpg"
              alt
              style="display:block;margin:auto"
              class="img img-responsive"
            />
            <h3
              style="text-align:center;font-weight:bold"
            >DEPARTMENT OF NUTRITION AND FOOD SCIENCE UNIVERSITY OF GHANA</h3>
            <h4
              style="text-align:center;font-weight:bold"
            >PhD Fellowship in Nutrition and Neurodevelopment - 2020/2021 Academic Year</h4>
          </div>
        </section>

        <section class="content" style="margin-bottom:20px">
			<!-- starts here -->
			 <download-excel class="btn btn-primary"
            :data="applicantlist"
            :export-fields ="export_fields"
            >
            Export Data
            </download-excel>
			<div class="row">
               <div class="col-sm-7">
             <div class="box" style="margin-top:5px">
                  <div class="box-header">
                    <h3 class="box-title">APPLICANTS : {{applicantlist.length}}</h3>
                 </div>
                  <div class="box-body">
                  <div class="row">
                      <div class="col-sm-12">
						  <input type="text" name="params" id="input">
                          <div class="table-responsive" style="height:900px;overflow:scroll">
                          <table class="table table-striped" >
                              <thead>
                                  <tr>
                                      <th>Title</th>
                                      <th>Name</th>
                                      <th>Nationality</th>
									  <th>Gender</th>
                                      <th>Email</th>
                                      <th>Phone</th>
                                      <th>Is Employed</th>
                                      <th>Status</th>
                                      <th>Action</th>
                                  </tr>
                              </thead>
                              <tbody>
								  <tr v-for="(i,index) in applicantlist" :key="i.id">
                                      <!-- <td><input type="checkbox" v-model="selected" :value="i.id"></td> -->
                                      <td>{{i.title}}</td>
                                      <td>{{i.surname}} {{i.othernames}}</td>
                                       <td>{{i.nationality}}</td>
                                      <td>{{i.gender}}</td>
                                       <td>{{i.email}}</td>
									   <td>{{i.phone}}</td>
									   <td>{{i.isemployed}}</td>
                                       <td>
										   <span v-if="i.submitted===0" class="label label-danger">Not Submitted</span>
										   <span v-if="i.submitted===1" class="label label-success">Submitted</span>
									   </td>
                                      <td>
                                         <a href="#" @click.prevent="showApplicantDetails(index)" class="btn btn-primary btn-sm">View</a>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                          </div>
                      </div>
                  </div>
                  </div>
				  <div style="margin-left:10px">
					  <Paginate :pagination="pgnate" @paginate="fetchApplicants()" :offset="4"/>  
				  </div>
				   
             </div>
               </div>
			   <!-- the other half starts here -->
				   <div class="col-sm-5">
                 <div class="box">
                     <div class="box-header ">
                         <h3 class="box-title">Complete Details</h3>
                    </div> 
                    <div class="box-body">
                <br><br>
                        <div class="table table-responsive">
                                <h3>BioData</h3>
								
								<img v-if="details.image" :src="'https://sts.ug.edu.gh/itsev8engine/public/phd/images/'+details.image" alt="" style="max-width:150px;display:block;margin:auto">
                            <table class="table" v-if="details.id">
                                <tbody>
                                <tr>
                                    <th>Title</th>
                                    <td>{{details.title}}</td>
                                </tr>
                                <tr>
                                    <th>Surname</th>
                                    <td>{{details.surname}}</td>
                                </tr>
                                <tr>
                                    <th>Othernames</th>
                                    <td>{{details.othernames}}</td>
                                </tr>
                                <tr>
                                    <th>Nationality</th>
                                    <td>{{details.nationality}}</td>
                                </tr>
                                <tr>
                                    <th>Phone</th>
                                    <td>{{details.phone}}</td>
                                </tr>
                                <tr>
                                    <th>Email</th>
                                    <td>{{details.email}}</td>
                                </tr>
                                
                                <tr>
                                    <th>Gender</th>
                                    <td>{{details.gender}}</td>
                                </tr>
								<tr>
                                    <th>Address</th>
                                    <td>{{details.address}}</td>
                                </tr>
                                 <tr>
                                    <th>Is Employed</th>
                                    <td>{{details.isemployed}}</td>
                                </tr>
                                 <tr>
                                    <th>Position</th>
                                    <td>{{details.position}}</td>
                                </tr>
                                 <tr>
                                    <th>Employer Name</th>
                                    <td>{{details.employername}}</td>
                                </tr>
                                  <tr>
                                    <th>Employer Email</th>
                                    <td>{{details.employeremail}}</td>
                                </tr>
                                <tr>
                                    <th>Employer Address</th>
                                    <td>{{details.employeraddress}}</td>
                                </tr>
                                </tbody>
                            </table>

							<h3>Employment History</h3>
							 <table class="table">
								 <thead>
									 <tr>
										 <th>Start Date</th>
										 <th>End Date</th>
										 <th>Position</th>
										 <th>Employer</th>
										 <th>Country</th>
									 </tr>
								 </thead>
								 <tbody>
									 <tr v-for="(i,index) in emphistory" :key="index">
										 <td>{{i.startDate}}</td>
										 <td>{{i.endDate}}</td>
										 <td>{{i.position}}</td>
										 <td>{{i.employer}}</td>
										 <td>{{i.country}}</td>
									 </tr>
								 </tbody>
							 </table>
								<br>
							 <h3>Educational Background</h3>
							 <table class="table">
								 <thead>
									 <tr>
										 <th>Start Date</th>
										 <th>End Date</th>
										 <th>Institution</th>
										 <th>Subjects</th>
										 <th>Degree</th>
									 </tr>
								 </thead>
								 <tbody>
									 <tr v-for="(i,index) in edubackground" :key="index">
										 <td>{{i.startDate}}</td>
										 <td>{{i.endDate}}</td>
										 <td>{{i.institution}}</td>
										 <td>{{i.subjects}}</td>
										 <td>{{i.degree}}</td>
									 </tr>
								 </tbody>
							 </table>
							 <br>
							 <h3>Documents Uploaded</h3>
							 <table class="table">
								 <thead>
									 <tr>
										 <th>Document Type</th>
										 <th>Doc Name</th>
										 <th>Action</th>
									 </tr>
								 </thead>
								 <tbody>
									 <tr v-for="(i,index) in docsuploaded" :key="index">
										 <td>{{i.type}}</td>
										 <td>{{i.name}}</td>
										<td>
											<a target="_blank" :href="'https://sts.ug.edu.gh/itsev8engine/public/phd/docs/'+i.name" class="btn btn-success">View</a>
										</td>
									 </tr>
								 </tbody>
							 </table>

                        </div>
                    </div>
                 </div>
             </div>
			   <!-- ends here -->
			</div>
			<!-- ends here -->
        </section>
      </div>
	   </div>

		<Footer/>
		<BlockUI v-show="isLoading" message="Please Wait" url="https://sts.ug.edu.gh/itsev8engine/public/images/loading.gif"></BlockUI>
  </div>
</template>

<script>
import Top from "./partials/Top.vue";
import Footer from "./partials/Footer.vue";
import Paginate from './Paginate.vue'
import JsonExcel from 'vue-json-excel'
export default {
  name: 'Dashboard',
  components:{
	  Top,
	  Footer,
	  Paginate,
	  'downloadExcel':JsonExcel
  },
  data(){
	  return {
		  export_fields:{
              "title":"title",	
              "surname":"surname",
              "othernames":"othernames",
              "nationality":"nationality",
              "phone":"phone",
              "email":"email",
              "gender":"gender",	
              "address":"address",	
              "isemployed":"isemployed",	
              "position":"position",	
              "employername":"employername",	
              "employeremail":"employeremail",	
              "employeraddress":"employeraddress"
          }, 
		   isLoading:false,
           theaction:'',
           currentindex:0,
           showloading:false,
		  username:'',
		  applicantlist:[],
		  edubackground:[],
		  emphistory:[],
		  docsuploaded:[],
		  details:{},
		  pgnate: {
            total: 0,
            per_page: 2,
            from: 1,
            to: 0,
            current_page: 1
        },
        offset: 4,
	  }
  },
  methods: {
	  fetchApplicants:function(){
		    let _this = this;
            this.isLoading = true;
          this.$http.get(this.appenv.baseurl+'/master/fetchapplicants'+'?page='+this.pgnate.current_page).then((res)=>{
              _this.applicantlist = res.data.response.data;
               _this.isLoading = false;
              _this.pgnate = res.data.response;
              _this.showApplicantDetails(0);
          }).catch(function(){
               _this.isLoading = false;
               // console.log(err);
          })
	  },

	   fetchExtraDetails:function(id){
		   let _this = this;
          this.$http.get(this.appenv.baseurl+'/master/fetchextradetails'+'/'+id).then((res)=>{
			  _this.edubackground = res.data.edubackground
				_this.emphistory = res.data.emphistory
				_this.docsuploaded = res.data.docsuploaded
          }).catch(function(){
			_this.edubackground = [];
		    _this.emphistory = [];
		    _this.docsuploaded = [];
		  });
	  },

	     next:function(){
      if(this.currentindex < this.applicantlist.length){
         if(this.currentindex==this.applicantlist.length){
           this.showApplicantDetails(this.applicantlist.length);
        }else{
          this.showApplicantDetails(++this.currentindex);
        }   
      } 
         
	},
	logout:function(){
          localStorage.removeItem('user');
          localStorage.removeItem('apikey');
          this.$router.push('/master/login');
      },
    previous:function(){
      if(this.currentindex >= 0){
        if(this.currentindex==0){
           this.showApplicantDetails(0);
        }else{
          this.showApplicantDetails(--this.currentindex);
        }   
    }
    },
       showApplicantDetails(index){
       let i  = this.applicantlist[index];
       if(i){
        this.details = i;
         this.currentindex = index;
	   }
	   this.fetchExtraDetails(this.details.id);

     },
  },

  mounted:function(){
      
      if(localStorage.getItem('user')){
          //console.log(localStorage.getItem('user')===null);
           if(localStorage.getItem('user') === 'undefined' || localStorage.getItem('user')===null){
               localStorage.removeItem('user');
               this.$router.push('/master/login');
           }else{
            var user = JSON.parse(localStorage.getItem('user'));
            this.username = user.username
           this.fetchApplicants();
           }    
      }else{
        localStorage.removeItem('user');
        this.$router.push('/master/login');
      }
      
  }

}
</script>

<style>

</style>
